export default __webpack_public_path__ + "static/media/iPermitPro.d18272c8.png";